import { T, Var } from 'gt-react';

import type { ComboboxLabels } from '@erp/ui/combobox';

/**
 * Translated `Combobox` labels for the frontend's pickers. These are the
 * strings (and contexts) the cmdk `Autocomplete` used, so existing
 * translations still apply. `search` is a plain string (an input
 * placeholder), so callers translate it with `gt`; the placeholder and empty
 * state default to the shared translations.
 */
export function pickerLabels(
  labels: Pick<ComboboxLabels, 'search'> &
    Partial<Pick<ComboboxLabels, 'placeholder' | 'empty'>>,
): Partial<ComboboxLabels> {
  return {
    placeholder: (
      <T context="autocomplete trigger placeholder when nothing is selected">
        Select option...
      </T>
    ),
    empty: <T context="autocomplete empty state">No results.</T>,
    ...labels,
    loading: (
      <T context="autocomplete loading the next batch of options">Loading…</T>
    ),
    loadMore: (
      <T context="button label to load more autocomplete options">Load more</T>
    ),
    clear: <T context="button label to clear autocomplete selection">Clear</T>,
    more: (count) => (
      <T context="count of additional selected items not shown">
        +<Var>{count}</Var> more
      </T>
    ),
    // Untranslated, as it was before the move; translating it is follow-up.
    remove: (label) => `Remove ${label}`,
  };
}
